export default "__VITE_ASSET__BElIHm74__"